import { ChartItemObj } from './chart-item.obj';

/** encapsulation d'un objet à afficher dans les charts à données en serie */
export class ChartSerieObj {
  public label: string; // nom de la série, utilisé pour la légende

  public minValue: number = 0; // borne de la série
  public maxValue: number = 0; // borne de la série

  private _items: ChartItemObj[] = []; // les items de la série
  public set items(value: ChartItemObj[]) {
    this._items = value;
    this.series = value;

    const bornes: { min: number, max: number } = this._items?.reduce((b: { min: number, max: number }, o) => {
      b.min = o.value < b.min ? o.value : b.min;
      b.max = o.value > b.max ? o.value : b.max;

      return b;
    }, { min: 0, max: 0}) || { min: 0, max: 0};

    this.minValue = bornes.min;
    this.maxValue = bornes.max;
  }
  public get items(): ChartItemObj[] {
    return this._items;
  }

  public name: string; // compatibilité charts
  public series: ChartItemObj[] = []; // compatibilité charts

  constructor(name: string, label: string) {
    this.label = label;
    this.name = name;
  }
}
